<template >
	<v-layout column class="elevation-5 ">
		<v-flex >
		<v-card class="" elevation="5" 
				:height="$vuetify.breakpoint.width > 1920 ? '610' : '610' ">
		<v-toolbar flat class="" :style="darkTheme ? 'color: whitesmoke;' : 'color: black;'">			
			<v-btn icon 
	          class=""
	          @click="setRoom(null)">
	          <v-icon class="grey--text text--darken-2">close</v-icon>
	        </v-btn>	
	        <v-toolbar-title>{{room.number}} ROOM DETAILS</v-toolbar-title>      
		</v-toolbar>
		<div v-if="!loadingRoomDetail" style="height: 2px;"></div>
		<v-progress-linear class="my-0" height="2" v-if="loadingRoomDetail" color="blue" indeterminate></v-progress-linear>
		
		<v-layout row  >
			<v-flex xs1 >
				<RoomQuickList v-if="room.roomKey"/>
			</v-flex>
			<v-flex xs5>
				<RoomDetailBasic v-if="room" class="" />	
			</v-flex>	
			<v-flex xs7>
				<RoomDetailDepts v-if="room.roomKey" class="ml-4"/>
			</v-flex>
		</v-layout>
		
		</v-card>
	</v-flex>
	</v-layout>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'
import RoomDetailBasic from '@/components/RoomViewer/RoomDetailBasic'
import RoomDetailDepts from '@/components/RoomViewer/RoomDetailDepts'
import RoomQuickList from '@/components/RoomViewer/RoomQuickList'


export default {
name: 'RoomDetail',
data () {
	return {}
},

components: { RoomDetailBasic, RoomDetailDepts, RoomQuickList },

computed: {
	...mapState({   	room: state => state.dv.room,
						loadingRoomDetail: state => state.dv.loadingRoomDetail,
						darkTheme: state => state.ui.darkTheme,

				})
},

methods : {
	...mapActions([ 	'setRoom',
					]),

	clickHandler : function () {
		console.log("Clicked")
	}
},
}

</script>

<style>
.offsetWidth {
	width: calc(100vw - 210px) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetail.vue